import { render, staticRenderFns } from "./QuitlyResourceGeneralPane.vue?vue&type=template&id=561acb44&"
import script from "./QuitlyResourceGeneralPane.vue?vue&type=script&lang=ts&"
export * from "./QuitlyResourceGeneralPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561acb44')) {
      api.createRecord('561acb44', component.options)
    } else {
      api.reload('561acb44', component.options)
    }
    module.hot.accept("./QuitlyResourceGeneralPane.vue?vue&type=template&id=561acb44&", function () {
      api.rerender('561acb44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/quiltyResource/QuitlyResourceGeneralPane.vue"
export default component.exports